export default "__VITE_ASSET__fbbddbca__"